import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Exit: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 22 22"
    >
      <rect
        id="Rectangle_1389"
        data-name="Rectangle 1389"
        width="22"
        height="22"
        fill="#176bfb"
        opacity="0"
      />
      <g id="Group_7125" data-name="Group 7125" transform="translate(1.889 2)">
        <path
          id="Path_5905"
          data-name="Path 5905"
          d="M28.475,21.451,24,15.975,28.475,10.5"
          transform="translate(-24 -6.92)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <g id="Group_7125-2" data-name="Group 7125">
          <path
            id="Path_5904"
            data-name="Path 5904"
            d="M4.5,22.611h7.562a1.911,1.911,0,0,0,1.79-2.012V6.512A1.911,1.911,0,0,0,12.062,4.5H4.5"
            transform="translate(4.259 -4.5)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_5906"
            data-name="Path 5906"
            d="M13.5,18H24.241"
            transform="translate(-13.5 -8.944)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Exit;
